import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import * as AuthActions from './store/auth.action';
import { AuthState } from './store/auth.model';
import { selectToken, selectUserId } from './store/auth.selector';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ToasterService } from '../providers/toaster/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly AUTH_KEY = 'auth_data';
  private apiUrl = environment.apiUrl
  constructor(private store: Store<AuthState>, private http: HttpClient, private router: Router, private toasterService: ToasterService) { }

  login(email: string, password: string): Observable<any> {
    this.store.dispatch(AuthActions.login({ email, password }));
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(`${this.apiUrl}login`, { email, password , action_for : 'super-admin'},{ headers: headers }).pipe(
      tap({
        next: (response: any) => {
          if (response.status === 'success') {
            const { token, user } = response.data;
            this.store.dispatch(AuthActions.loginSuccess({ user, token }));
            this.saveAuthDataToLocalStorage(user, token);
            this.router.navigate(['/dashboard']);
            this.toasterService.setToaster('success', 'login success', response.message)
          } else {
            this.store.dispatch(AuthActions.loginFailure({ error: response.message }));
            this.toasterService.setToaster('error', 'login failed', response.message)
          }
        },
        error: (error) => {
          this.toasterService.setToaster('error', 'login failed', 'something went wrong')
          this.store.dispatch(AuthActions.loginFailure({ error: error.message }));
        }
      })
    );
  }

  logout(): void {
    this.store.dispatch(AuthActions.logout());
    this.clearAuthDataFromLocalStorage();
    this.router.navigate(['/login']);
  }

  loadAuthDataFromLocalStorage(): void {
    const authData = localStorage.getItem(this.AUTH_KEY);

    if (authData) {
      const { user, token } = JSON.parse(authData);
      this.store.dispatch(AuthActions.loadAuthDataFromLocalStorage({ user, token }));
    } else {
      this.store.dispatch(AuthActions.logout()); // or a specific reset action
    }
  }


  private saveAuthDataToLocalStorage(user: any, token: string): void {
    const authData = { user, token };
    localStorage.setItem(this.AUTH_KEY, JSON.stringify(authData));
  }

  private clearAuthDataFromLocalStorage(): void {
    localStorage.removeItem(this.AUTH_KEY);
  }

  getToken(): Observable<string | null> {
    return this.store.select(selectToken);
  }

  getHeader(): Observable<HttpHeaders> {
    return this.store.select(selectToken).pipe(
      map((token) => {
        if (!token) {
          const authData = localStorage.getItem(this.AUTH_KEY);
          if (authData) {
            const { token } = JSON.parse(authData);
            if (token) {
              return new HttpHeaders({
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',

              });
            }
          }
          this.logout();
        }
        return new HttpHeaders({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        });
      })
    );
  }

  tokenExpire() {
    this.logout();
    this.toasterService.setToaster('error', 'Session Expired', 'The session has expired. Please log in again.');
  }


}